import { graphql } from 'react-relay';

// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { queryInterop } from '@confluence/apollo-relay-interop/entry-points/query.ts';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';

import type {
	fetchMentionsProviderDataQuery$data,
	fetchMentionsProviderDataQuery$variables,
} from './__generated__/fetchMentionsProviderDataQuery.graphql.ts';

const fetchMentionsProviderDataQuery = graphql`
	query fetchMentionsProviderDataQuery {
		entitlements {
			externalCollaborator {
				isEntitled
			}
		}
	}
`;

export const fetchMentionsProviderData = async (): Promise<
	fetchMentionsProviderDataQuery$data | undefined
> => {
	return queryInterop<
		fetchMentionsProviderDataQuery$data,
		fetchMentionsProviderDataQuery$variables
	>({
		query: fetchMentionsProviderDataQuery,
	})
		.then(({ data }) => {
			return data;
		})
		.catch((error) => {
			getMonitoringClient().submitError(error, {
				attribution: Attribution.ADMIN_EXPERIENCE,
			});
			markErrorAsHandled(error);
			return undefined;
		});
};
